// src/components/Admin/Auth/Auth.js
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { RegisterForm, LoginForm } from "../../../components/Admin/Auth"; // mismo barrel
import { LanguageSwitcher } from "../../../components/Admin/AdminLayout/LanguageSwitcher";
import { logoEduca } from "../../../assets";
import { NEW_LOGIN } from "../../../ui/featureFlags";
import { AuthIntro } from "./AuthIntro/AuthIntro";
import "./Auth.scss";

// Duracion de la transicion de salida (portal) antes de entrar al portal.
// Coincide con el final del fundido a negro del AuthIntro (~2.05s).
const EXIT_MS = 2100;

export function Auth() {
  const [isLogin, setIsLogin] = useState(true);
  const [exiting, setExiting] = useState(false);
  const { t } = useTranslation("auth");

  // Login correcto: lanza la transicion de salida y resuelve cuando termina,
  // para que LoginForm navegue al portal justo despues.
  const handleAuthSuccess = useCallback(
    () =>
      new Promise((resolve) => {
        setExiting(true);
        setTimeout(resolve, EXIT_MS);
      }),
    [],
  );

  // Contenido del panel (logica intacta): logo + idioma + form + switch
  const cardContent = (
    <>
      {/* Logo de Educa360 */}
      <img src={logoEduca.logoE360} alt="Educa360" className="auth-logo" />

      {/* Language switcher */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginBottom: 8,
        }}
      >
        <LanguageSwitcher />
      </div>

      {/* Aquí pasamos openLogin al RegisterForm */}
      {isLogin ? (
        <LoginForm onAuthSuccess={NEW_LOGIN ? handleAuthSuccess : undefined} />
      ) : (
        <RegisterForm openLogin={() => setIsLogin(true)} />
      )}

      {/* Link para cambiar entre Login y Sign Up */}
      <div className="auth-switch">
        {isLogin ? (
          <>
            {t("auth.noAccount")}{" "}
            <button
              type="button"
              className="link-btn"
              onClick={() => setIsLogin(false)}
            >
              {t("auth.createAccount")}
            </button>
          </>
        ) : (
          <>
            {t("auth.haveAccount")}{" "}
            <button
              type="button"
              className="link-btn"
              onClick={() => setIsLogin(true)}
            >
              {t("auth.signIn")}
            </button>
          </>
        )}
      </div>
    </>
  );

  if (NEW_LOGIN) {
    return <AuthIntro exiting={exiting}>{cardContent}</AuthIntro>;
  }

  return (
    <div className="auth-container">
      <div className="auth-card">{cardContent}</div>
    </div>
  );
}
